import React from 'react';

import TinyJellyShape from './../../containers/UI/Common/JellyShape/TinyJellyShape';

const WavyLayout = (props) => ( 

    <div className={`wavy-page-container ${props.page}`}>
        <div className="page-container">
            <h3>{props.title}</h3>
            <div className="close-page" onClick={props.handleClick}></div>
            <div className="header" >
                <TinyJellyShape color={props.color} translate={props.translate} />
            </div>
            { props.children }
        </div>  
    </div>
    
);

export default WavyLayout;


// WEBPACK FOOTER //
// ./src/hoc/WavyLayout/WavyLayout.js